module.exports = "/_next/static/images/5001295cdcd5fa41c5a5e9b60e088687-rewards-hosting@0.5x.png.webp";